export const companyInfo = {
  name: "REGIORENT Y OBRA",
  subtitle: "SA DE CV",
  tagline: "Soluciones de Obra Civil y Renta de Maquinaria Pesada",
  description:
    "Somos una empresa 100% mexicana en constante crecimiento en el área de la construcción y desarrollos inmobiliarios. Nuestras perspectivas se enfocan en la evolución y adecuación con las exigencias del mercado siempre cambiante, para desarrollar nuevos, mejores y mayores proyectos.",
  mission:
    "Proveer a los mercados locales y nacionales soluciones de obra civil en general, acabados, obra residencial, terracerías, excavaciones, industrial y comercial, satisfaciendo en forma integral las necesidades de nuestros clientes, cumpliendo con los proyectos de la más alta calidad, en tiempo y forma.",
  vision:
    "Ser una empresa con calidad moral limpia, hacer crecer a nuestros clientes y colaboradores, alcanzar metas proyectadas año con año y transformarnos día a día en la compañía más confiable, eficaz, honesta y con menos costos a nivel nacional.",
  values: [
    "Honestidad y Ética",
    "Respeto por nuestra gente y provocar un desarrollo personal",
    "Responsabilidad al cumplir compromisos",
    "Promover trabajo en equipo",
    "Estrictos con la calidad para cumplir con las expectativas del cliente",
    "Mejora continua en nuestro aprendizaje",
  ],
  address:
    "Morelia 102 Col. Las Encinas, C.P 66050, Ciudad General Escobedo, Nuevo León.",
  phone1: "8115105759",
  phone2: "8129095585",
  engineers: [
    { name: "Ing. Rafael Flores", role: "Ingeniero de Proyectos" },
    { name: "Ing. Omar García", role: "Ingeniero de Operaciones" },
  ],
};

export const services = [
  "Obra Civil en General",
  "Acabados",
  "Obra Residencial",
  "Terracerías",
  "Excavaciones",
  "Obra Industrial y Comercial",
  "Obra Eléctrica (Alta, Media y Baja Tensión)",
  "Cimentaciones",
  "Estructuras y Laminación",
  "Carpeta Asfáltica",
];

export const certifications = [
  "Registro REPSE",
  "Trabajos en Alturas",
  "Condiciones de Seguridad e Higiene (EPP)",
  "Manejo de Extintores",
  "Aseguramiento de Energía (Bloqueo y Candadeo)",
];

export interface Equipment {
  id: string;
  name: string;
  category: "equipo-ligero" | "maquinaria" | "flete" | "escombro";
  categoryLabel: string;
  description: string;
  specs: string[];
  available: boolean;
  image: string;
}

export const equipmentData: Equipment[] = [
  {
    id: "eq-01",
    name: "Rompedora 30 KG",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Rompedora de concreto de alto impacto para demoliciones y trabajos pesados.",
    specs: ["Peso: 30 kg", "Potencia: 1,500W", "Impactos/min: 1,300"],
    available: true,
    image:
    "/equipos/rompedora30k.jpg",
  },
  {
    id: "eq-02",
    name: "Rompedora 15 KG",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Rompedora compacta ideal para trabajos de demolición ligera y acabados.",
    specs: ["Peso: 15 kg", "Potencia: 900W", "Impactos/min: 1,100"],
    available: true,
    image:
      "/equipos/rompedora15k.jpg",
  },
  {
    id: "eq-03",
    name: "Rompedora 9 KG",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Rompedora ligera para trabajos de precisión en demolición y remodelación.",
    specs: ["Peso: 9 kg", "Potencia: 700W", "Impactos/min: 950"],
    available: true,
    image:
      "/equipos/rompedora9k.jpg",
  },
  {
    id: "eq-04",
    name: "Compactadoras",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Compactadoras para consolidación de suelos y bases en construcción.",
    specs: [
      "Fuerza centrífuga: 20-30 kN",
      "Ancho: 50-80 cm",
      "Motor: Gasolina/Diésel",
    ],
    available: true,
    image:
      "/equipos/compactora.jpg",
  },
  {
    id: "eq-05",
    name: "Cortadora de Concreto",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Cortadora de concreto con disco diamantado para cortes precisos en pavimento y losas.",
    specs: [
      "Diámetro disco: 350-500mm",
      "Profundidad corte: hasta 180mm",
      "Motor: 5.5 HP",
    ],
    available: true,
    image:
      "/equipos/cortadora-concreto.jpg",
  },
  {
    id: "eq-06",
    name: "Torre de Iluminación",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Torre de iluminación portátil para seguridad y visibilidad en obras nocturnas.",
    specs: ["Potencia: 4x1,000W", "Altura: 6-9 metros", "Autonomía: 18 hrs"],
    available: true,
    image:
      "/equipos/torre.jpg",
  },
  {
    id: "eq-07",
    name: "Generador Eléctrico 10,000W",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Generador de alta potencia para alimentar herramientas y equipos en sitio de obra.",
    specs: [
      "Potencia: 10,000W",
      "Combustible: Gasolina/Diésel",
      "Voltaje: 120/240V",
    ],
    available: true,
    image:
      "/equipos/generador.jpg",
  },
  {
    id: "eq-08",
    name: "Juego de Andamios",
    category: "equipo-ligero",
    categoryLabel: "Equipo Ligero",
    description:
      "Sistema de andamios certificados para trabajos en alturas con máxima seguridad.",
    specs: [
      "Material: Acero galvanizado",
      "Carga máxima: 200 kg/m²",
      "Altura: hasta 40m",
    ],
    available: true,
    image:
      "/equipos/jandamios.jpg",
  },
  {
    id: "eq-09",
    name: "Retroexcavadora",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Retroexcavadora multifuncional para excavación, carga y movimiento de tierra.",
    specs: [
      "Capacidad cucharón: 0.8-1.2 m³",
      "Profundidad max: 5.5 m",
      "Motor: Diésel 130 HP",
    ],
    available: true,
    image:
      "/equipos/retroexcavadora.jpg",
  },
  {
    id: "eq-10",
    name: "Excavadora",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Excavadora hidráulica de orugas para trabajos pesados de excavación y demolición.",
    specs: [
      "Capacidad cucharón: 1.5-2.5 m³",
      "Peso operación: 22 ton",
      "Motor: Diésel 160 HP",
    ],
    available: true,
    image:
      "/equipos/excavadora.jpg",
  },
  {
    id: "eq-11",
    name: "Motoniveladora",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Motoniveladora para nivelación y preparación de terrenos y carreteras.",
    specs: [
      "Largo cuchilla: 3.7 m",
      "Peso operación: 14 ton",
      "Motor: Diésel 140 HP",
    ],
    available: true,
    image:
      "/equipos/motoniveladora.jpg",
  },
  {
    id: "eq-12",
    name: "Rodillo 1.5 Ton.",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Rodillo vibratorio compactador ligero para acabados en pavimento y bases.",
    specs: ["Peso: 1.5 ton", "Ancho: 1.2 m", "Vibración: 70 kN"],
    available: true,
    image:
      "/equipos/rodillo1.5.jpg",
  },
  {
    id: "eq-13",
    name: "Rodillo 3 Ton.",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Rodillo compactador de media tonelada para compactación de suelos y asfalto.",
    specs: ["Peso: 3 ton", "Ancho: 1.5 m", "Vibración: 90 kN"],
    available: true,
    image:
      "/equipos/rodillo3.jpg",
  },
  {
    id: "eq-14",
    name: "Rodillo 7 Ton.",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Rodillo pesado de doble tambor para compactación profunda de capas de terracería.",
    specs: ["Peso: 7 ton", "Ancho: 1.8 m", "Vibración: 120 kN"],
    available: true,
    image:
      "/equipos/rodillo7.jpg",
  },
  {
    id: "eq-15",
    name: "Rodillo 10 Ton.",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Rodillo de alta capacidad para proyectos de carreteras e infraestructura grande.",
    specs: ["Peso: 10 ton", "Ancho: 2.1 m", "Vibración: 150 kN"],
    available: true,
    image:
      "/equipos/rodillo10.jpg",
  },
  {
    id: "eq-16",
    name: "Pipa de Agua 10,000 Lts",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Tanque de agua para control de polvo y abastecimiento en sitio de obra.",
    specs: [
      "Capacidad: 10,000 litros",
      "Material: Acero inoxidable",
      "Bomba de agua: Incluida",
    ],
    available: true,
    image:
      "/equipos/pipa10.jpg",
  },
  {
    id: "eq-17",
    name: "Pipa de Agua 20,000 Lts",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Tanque de agua de alta capacidad para proyectos grandes y control ambiental.",
    specs: [
      "Capacidad: 20,000 litros",
      "Material: Acero inoxidable",
      "Bomba de agua: Incluida",
    ],
    available: true,
    image:
      "/equipos/pipa20.jpg",
  },
  {
    id: "eq-18",
    name: "Minicargador (Bobcat)",
    category: "maquinaria",
    categoryLabel: "Maquinaria Pesada",
    description:
      "Minicargador multifuncional para carga, acarreo y movimiento de materiales en espacios reducidos.",
    specs: [
      "Capacidad: 0.8 m³",
      "Peso: 3.2 ton",
      "Motor: Diésel 74 HP",
    ],
    available: true,
    image:
      "/equipos/mini.jpg",
  },
  {
    id: "eq-19",
    name: "Flete 7 M3",
    category: "flete",
    categoryLabel: "Fletes",
    description:
      "Camión de acarreo de material para carga y transporte de tierra y escombro.",
    specs: ["Capacidad: 7 m³", "Tipo: Torton", "Material: Tierra/Mixto"],
    available: true,
    image:
      "/equipos/flete7.jpg",
  },
  {
    id: "eq-20",
    name: "Flete 14 M3",
    category: "flete",
    categoryLabel: "Fletes",
    description:
      "Camión de carga mediana para transporte eficiente de materiales de construcción.",
    specs: ["Capacidad: 14 m³", "Tipo: 7.5 ton", "Material: Tierra/Mixto"],
    available: true,
    image:
      "/equipos/flete14.jpg",
  },
  {
    id: "eq-21",
    name: "Flete 30 M3",
    category: "flete",
    categoryLabel: "Fletes",
    description:
      "Camión de gran capacidad para proyectos de alta volumetría y acarreo pesado.",
    specs: ["Capacidad: 30 m³", "Tipo: Tandem", "Material: Tierra/Mixto"],
    available: true,
    image:
      "/equipos/flete30.jpg",
  },
  {
    id: "eq-22",
    name: "Retiro de Escombro 7 M3",
    category: "escombro",
    categoryLabel: "Escombro",
    description:
      "Retiro y acarreo de escombro de construcción para limpieza de sitio.",
    specs: ["Capacidad: 7 m³", "Disponibilidad: Inmediata", "Cobertura: ZMNL"],
    available: true,
    image:
      "/equipos/Retiro-de-escombro.jpg",
  },
  {
    id: "eq-23",
    name: "Retiro de Escombro 14 M3",
    category: "escombro",
    categoryLabel: "Escombro",
    description:
      "Servicio de retiro de escombro de mediana capacidad para demoliciones y remodelaciones.",
    specs: ["Capacidad: 14 m³", "Disponibilidad: Inmediata", "Cobertura: ZMNL"],
    available: true,
    image:
      "/equipos/Retiro-de-escombro14.jpg",
  },
  {
    id: "eq-24",
    name: "Retiro de Escombro 30 M3",
    category: "escombro",
    categoryLabel: "Escombro",
    description:
      "Retiro de escombro de alta capacidad para proyectos industriales y comerciales.",
    specs: ["Capacidad: 30 m³", "Disponibilidad: Inmediata", "Cobertura: ZMNL"],
    available: true,
    image:
      "/equipos/Retiro-de-escombro30.jpg",
  },
];

export interface Project {
  id: string;
  title: string;
  client: string;
  location: string;
  type: string;
  region: string;
  description: string;
  images: string[];
  year: string;
  status: "completado" | "en-progreso";
}

export const projectsData: Project[] = [
  {
    id: "proj-01",
    title: "Cimentaciones para Máquinas Ensambladoras",
    client: "YUE SHUI",
    location: "Parque Industrial La Joya, N.L.",
    type: "Industrial",
    region: "Monterrey",
    description:
      "Trabajo de cimentaciones especiales para maquinaria ensambladora de alta precisión en parque industrial.",
    images: [
      "https://images.unsplash.com/photo-1503708928676-1cb796a0891e?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1630288214032-2c4cc2c080ca?w=800&h=500&fit=crop",
    ],
    year: "2024",
    status: "completado",
  },
  {
    id: "proj-02",
    title: "Terracerías Mi Tiendita",
    client: "Maiz Edificaciones",
    location: "Santa María, Lincoln, N.L.",
    type: "Comercial",
    region: "Lincoln",
    description:
      "Trabajo completo de terracerías para establecimiento comercial de nueva generación.",
    images: [
      "https://images.unsplash.com/photo-1630288214117-5ebf6c9de343?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1702359562653-14a321274d47?w=800&h=500&fit=crop",
    ],
    year: "2024",
    status: "completado",
  },
  {
    id: "proj-03",
    title: "Terracería para Estacionamiento",
    client: "CEMEX",
    location: "Campos de Entrenamiento Tigres, San Nicolás",
    type: "Infraestructura Deportiva",
    region: "Monterrey",
    description:
      "Preparación de terreno y terracería para estacionamiento de grandes dimensiones en complejo deportivo.",
    images: [
      "https://images.unsplash.com/photo-1580901369227-308f6f40bdeb?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1606331531016-cffd5ec1a433?w=800&h=500&fit=crop",
    ],
    year: "2024",
    status: "completado",
  },
  {
    id: "proj-04",
    title: "Gasolinera Delta",
    client: "DELTA",
    location: "Santo Domingo, Apodaca, N.L.",
    type: "Comercial",
    region: "Apodaca",
    description:
      "Construcción integral de gasolinera incluyendo terracerías, impermeabilización y pavimento.",
    images: [
      "https://images.unsplash.com/photo-1649829726631-fcd218631ab5?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1495036019936-220b29b930ea?w=800&h=500&fit=crop",
    ],
    year: "2023",
    status: "completado",
  },
  {
    id: "proj-05",
    title: "Estructura y Laminación de Nave",
    client: "CLARIOS",
    location: "Ciénega de Flores, N.L.",
    type: "Industrial",
    region: "Ciénega de Flores",
    description:
      "Erection of industrial warehouse structure with metal lamination and concrete flooring.",
    images: [
      "https://images.unsplash.com/photo-1583024011792-b165975b52f5?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1694521787162-5373b598945c?w=800&h=500&fit=crop",
    ],
    year: "2023",
    status: "completado",
  },
  {
    id: "proj-06",
    title: "Estructura y Lona para Área Comedor",
    client: "CLARIOS",
    location: "Ciénega de Flores, N.L.",
    type: "Industrial",
    region: "Ciénega de Flores",
    description:
      "Construcción de estructura metálica con cobertura de lona para área de comedor de personal industrial.",
    images: [
      "https://images.unsplash.com/photo-1694521787799-ad4ad241cb39?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=500&fit=crop",
    ],
    year: "2023",
    status: "completado",
  },
  {
    id: "proj-07",
    title: "Carpeta Asfáltica",
    client: "DELTA PROYECTOS",
    location: "García, N.L.",
    type: "Infraestructura Vial",
    region: "García",
    description:
      "Instalación de carpeta asfáltica de alta calidad para desarrollo comercial e industrial.",
    images: [
      "https://images.unsplash.com/photo-1606331531016-cffd5ec1a433?w=800&h=500&fit=crop",
      "https://images.unsplash.com/photo-1630288214032-2c4cc2c080ca?w=800&h=500&fit=crop",
    ],
    year: "2023",
    status: "completado",
  },
];

export const testimonials = [
  {
    id: "t-01",
    name: "Ing. Carlos Mendoza",
    company: "CEMEX",
    text: "REGIORENT demostró un nivel excepcional de profesionalismo en la terracería de nuestro estacionamiento. Cumplieron en tiempo y forma con estándares de calidad superiores.",
    rating: 5,
  },
  {
    id: "t-02",
    name: "Lic. María Fernández",
    company: "DELTA Proyectos",
    text: "La carpeta asfáltica que instalaron superó nuestras expectativas. Su equipo de trabajo es altamente capacitado y la maquinaria que utilizan es de primera calidad.",
    rating: 5,
  },
  {
    id: "t-03",
    name: "Ing. Roberto Sánchez",
    company: "YUE SHUI",
    text: "Las cimentaciones para nuestras máquinas ensambladoras fueron ejecutadas con precisión milimétrica. Su experiencia en obra industrial es evidente en cada detalle.",
    rating: 5,
  },
  {
    id: "t-04",
    name: "Arq. Patricia López",
    company: "Maiz Edificaciones",
    text: "Trabajamos con REGIORENT en múltiples proyectos y siempre superan las expectativas. Su compromiso con la calidad y el cumplimiento de tiempos los hace una opción confiable.",
    rating: 5,
  },
  {
    id: "t-05",
    name: "Ing. Alejandro Torres",
    company: "CLARIOS",
    text: "La estructura y laminación de nuestra nave industrial fue impecable. REGIORENT cuenta con el equipo humano y tecnológico para proyectos de gran envergadura.",
    rating: 5,
  },
];

export const activeWorksites = [
  {
    id: "site-01",
    name: "Centro Comercial Las Torres",
    lat: 25.7234,
    lng: -100.3456,
    address: "Av. Torres, Monterrey, N.L.",
    type: "Comercial",
    progress: 65,
  },
  {
    id: "site-02",
    name: "Parque Industrial Apodaca III",
    lat: 25.7968,
    lng: -100.1862,
    address: "Parque Industrial Apodaca, N.L.",
    type: "Industrial",
    progress: 40,
  },
  {
    id: "site-03",
    name: "Vialidad Santiago",
    lat: 25.3714,
    lng: -100.1521,
    address: "Carretera a Santiago, N.L.",
    type: "Infraestructura Vial",
    progress: 80,
  },
  {
    id: "site-04",
    name: "Bodega Ciénega de Flores",
    lat: 25.9564,
    lng: -100.1744,
    address: "Ciénega de Flores, N.L.",
    type: "Industrial",
    progress: 55,
  },
  {
    id: "site-05",
    name: "Residencial Garcia Norte",
    lat: 25.8103,
    lng: -100.5836,
    address: "García, Nuevo León",
    type: "Residencial",
    progress: 30,
  },
];

export const projectTypes = [
  "Todos",
  "Industrial",
  "Comercial",
  "Residencial",
  "Infraestructura Vial",
  "Infraestructura Deportiva",
];

export const regions = [
  "Todas",
  "Monterrey",
  "Apodaca",
  "Ciénega de Flores",
  "García",
  "Lincoln",
  "San Nicolás",
  "Santa María",
];

export const maintenanceHistory = [
  {
    date: "2025-12-15",
    equipment: "Retroexcavadora CAT 320",
    type: "Cambio de aceite y filtros",
    hours: "2,500 hrs",
    status: "Completado",
  },
  {
    date: "2025-11-28",
    equipment: "Motoniveladora 140M",
    type: "Inspección hidráulica general",
    hours: "3,100 hrs",
    status: "Completado",
  },
  {
    date: "2025-11-10",
    equipment: "Rodillo 10 Ton.",
    type: "Revisión de vibración y rodamiento",
    hours: "1,800 hrs",
    status: "Completado",
  },
  {
    date: "2025-10-22",
    equipment: "Minicargador Bobcat S650",
    type: "Cambio de correa y tensador",
    hours: "2,100 hrs",
    status: "Completado",
  },
  {
    date: "2025-10-05",
    equipment: "Generador 10,000W",
    type: "Service preventivo completo",
    hours: "500 hrs",
    status: "Completado",
  },
  {
    date: "2025-09-18",
    equipment: "Excavadora PC200",
    type: "Cambio de cadena y rodillos",
    hours: "4,200 hrs",
    status: "Completado",
  },
];
